var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJordan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_25_2769)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25_2769",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25_2769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.2819 3H3V23H37.2819V3Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2819 9.6622H3V16.3311H37.2819V9.6622Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2819 16.3311H3V23H37.2819V16.3311Z",
    fill: "#347C41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3V23L23 12.9967L3 3Z",
    fill: "#BD1F34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18012 11.5705L8.87211 12.3539L8.06194 12.1061L8.48377 12.836L7.78741 13.3114L8.61768 13.4386L8.55742 14.2822L9.18012 13.7131L9.79612 14.2822L9.73586 13.4386L10.5728 13.3114L9.87647 12.836L10.2983 12.1061L9.48812 12.3539L9.18012 11.5705Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_25_2769",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_25_2769"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_25_2769",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJordan);
export default __webpack_public_path__ + "static/media/Jordan.4538c1ed16bd4d7b37c10fea6fae7599.svg";
export { ForwardRef as ReactComponent };